<ng-container *ngrxLet="selectDatabaseTags$; let list">
    <ng-container *ngrxLet="setIsLoading$; let isLoading">
        <div class="ui-tab w-100 h-100 flex-col gap-16">
            <div class="flex-row space-between-center">
                <ui-search style="width: 320px"
                           [searchQuery]="search()"
                           (onInput)="search.set($event)"
                           [placeholder]="'DATABASE_TAGS.PLACEHOLDERS.SEARCH'|translate"></ui-search>
                <ui-button [text]="'DATABASE_TAGS.BUTTONS.CREATE'|translate"
                           (click)="create()"></ui-button>
            </div>

            <div class="h-100 min-h-0">
                <div class="h-100 min-h-0 flex-col">
                    <ng-container *ngIf="!isLoading; else loader">
                        <ng-container *ngIf="list?.length && tableConfig(); else noDataResult">
                            <ui-dataset-table [data]="list"
                                              [config]="tableConfig()!"
                                              (rowAction)="onRowAction($event)"></ui-dataset-table>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>

<!-- CELL TEMPLATES -->
<ng-template #nameCell
             let-row>
    <div class="flex-row start-center gap-8">
        <div class="color"
             [style.background-color]="row.color || defaultTagColor"></div>
        <div>{{ row.name }}</div>
    </div>
</ng-template>

<ng-template #isShownInLeftPanelCell
             let-row>
    @if(row.isShownInLeftPanel === undefined || row.isShownInLeftPanel === true) {
    <span class="ui-icon-checkmark"></span>
    } @else {
    <span class="ui-icon-close"></span>
    }
</ng-template>

<ng-template #noDataResult>
    <ui-no-data [imgSrc]="noResults.imgSrc"
                [title]="noResults.title|translate">
    </ui-no-data>
</ng-template>

<ng-template #loader>
    <ui-preloader [color]="loaderColor.blue"
                  style="padding: 100px 0;"></ui-preloader>
</ng-template>